var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.online)?_c('FeatherIcon',{attrs:{"type":"circle","size":"10px","stroke":"#10b759","fill":"#10b759"}}):_c('FeatherIcon',{attrs:{"type":"circle","size":"10px","stroke":"#7987a1","fill":"#7987a1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }